import { SCALE } from '../../constants';
import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const useStyles = makeStyles({
  table: {
    overflow: 'auto',
    borderRadius: 10 * SCALE,
    color: '#333333',
    boxShadow: 'none',

    '& tr:last-child td:first-child': {
      border: `${1 * SCALE}px solid #fff`,
      borderBottomLeftRadius: 10 * SCALE,
    },

    '& tr:last-child td:last-child': {
      border: `${1 * SCALE}px solid #fff`,
      borderBottomRightRadius: 10 * SCALE,
    },
    '& tr:first-child th:first-child': {
      border: `${1 * SCALE}px solid #fff`,
      borderTopLeftRadius: 10 * SCALE,
    },

    '& tr:first-child th:last-child': {
      border: `${1 * SCALE}px solid #fff`,
      borderTopRightRadius: 10 * SCALE,
    },

    '& .MuiTableHead-root > .MuiTableRow-root': {
      '& .MuiTableCell-root': {
        padding: `${6 * SCALE}px ${8 * SCALE}px`,
        backgroundColor: 'transparent',
        verticalAlign: 'middle',

        fontSize: 8 * SCALE,
        fontWeight: 400,
        border: `${1 * SCALE}px solid #fff`,
        lineHeight: `${12 * SCALE}px`,
      },
    },
  },
  tableBody: {
    '& .MuiTableRow-root': {
      '& .MuiTableCell-root': {
        fontFamily: 'OpenSans',
        padding: `${4 * SCALE}px ${8 * SCALE}px`,
        fontSize: 8 * SCALE, // 10px / (595 /100vw)px
        verticalAlign: 'middle',
        border: `${1 * SCALE}px solid #fff`,
        boxSizing: 'border-box',
      },
    },
  },
  tableCellFooter: {
    borderBottom: 'none',
  },
});
const TableCom = ({ data, lastRowData, nphsYear }) => {
  const classes = useStyles();

  const columns = useMemo(() => {
    if (isEmpty(data)) return [];
    return data[0]?.map((it) => it);
  }, [data]);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {columns.map((item) => (
          <TableCell
            key={item.value}
            style={{
              padding: `${6 * SCALE}px ${8 * SCALE}px`,
              minWidth: item.minWidth,
              maxWidth: item.maxWidth,
              width: item.width,
              backgroundColor: item.color,
              height: item.height,
            }}
            align="center"
          >
            {item.value}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
  return (
    <TableContainer elevation={0} component={Paper}>
      <Table className={classes.table}>
        <TableHeader />

        <TableBody className={classes.tableBody}>
          {!isEmpty(data) &&
            data.map((rows, rowsInx) => {
              return (
                rowsInx !== 0 && (
                  <TableRow key={`${rowsInx}`}>
                    {rows.map((cell, cellsInx) => (
                      <TableCell
                        key={`row${rowsInx}-${cellsInx}`}
                        align="center"
                        style={{
                          backgroundColor: cell.color,
                          height: cell.height,
                        }}
                      >
                        {cell.value}
                      </TableCell>
                    ))}
                  </TableRow>
                )
              );
            })}
          {nphsYear ? (
            <TableRow>
              <TableCell
                align="center"
                style={{
                  backgroundColor: '#E0E0E0',
                  height: 24 * SCALE,
                }}
              >
                NPHS {nphsYear}
              </TableCell>
              {lastRowData.map((cell) => (
                <TableCell
                  key={`${cell.value}-${cell.colSpan}`}
                  align="center"
                  colSpan={cell.colSpan}
                  style={{
                    backgroundColor: cell.color,
                  }}
                >
                  {cell.value}%
                </TableCell>
              ))}
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCom;
